
namespace TerminalApp {

    export class OrderSearcherAssistant extends Assistant {
        orderSearch_menu = document.createElement("div");
        search_input = document.createElement("input");

        order_suggestion_container = document.createElement("div");

        searchId = 0;

        callback: (orderInfo: SP.OrderInfo, customerInfo: SP.CustomerInfo) => void;

        constructor() {
            super();
            this.container.classList.add("assistant");

            // Setup Search Html
            var headline = this.orderSearch_menu.appendChild(document.createElement("h1"));
            headline.innerHTML = SP.Localize("sentance_search_order");

            this.search_input.type = "text";
            this.search_input.placeholder = SP.Localize("sentance_search_order");
            this.search_input.autocomplete = "off";
            this.search_input.tabIndex = 1;
            this.search_input.classList.add("search_input", "form-control");

            this.order_suggestion_container.classList.add("order_suggestion_container");

            // AppendChilds
            this.orderSearch_menu.appendChild(this.search_input);
            this.orderSearch_menu.appendChild(this.order_suggestion_container);

            this.container.appendChild(this.orderSearch_menu);

            // Eventlistners

            let to = null as any;
            this.search_input.addEventListener('keyup', () => {
                this.searchId++;
                clearTimeout(to);
                to = setTimeout(() => {
                    this.search(this.search_input.value, false, this.searchId);
                }, 500);
            });
        }


        async search(keyword: string, autopick: boolean, searchId: number) {
            try {
                this.order_suggestion_container.innerHTML = `
                    <video autoplay muted loop class="positionMiddel">
                        <source src="/terminal/img/loading.webm" type="video/webm" />
                    </video>
                `;

                let orders = await SP.Data.Order.searchOrderInfosBasic(keyword);
                if (searchId != this.searchId) {
                    return;
                }

                this.order_suggestion_container.innerHTML = "";

                for (var i = 0; i < orders.length; i++) {
                    let customer = await SP.Data.Customer.getCustomerInfo(orders[i].customerId, true);
                    this.addOrder(orders[i], customer);
                }
            } catch {

            }
        }


        hide() {
            this.orderSearch_menu.style.display = "none";
        }

        open_orderSearchMenu() {
            this.hide();
            this.container.style.display = "block";
            this.orderSearch_menu.style.display = "block";
            this.search_input.focus();
        }

        async open(callback: (orderInfo: SP.OrderInfo, customerInfo: SP.CustomerInfo) => void) {
            this.callback = callback;
            this.open_orderSearchMenu();
        }

        close() {
            super.close();
            this.clear();
        }

        clear() {
            this.search_input.value = "";
            this.order_suggestion_container.innerHTML = "";
            this.container.style.display = "none";
        }

        addOrder(order: SP.OrderInfo, customer: SP.CustomerInfo) {
            let searchResultContainer = this.order_suggestion_container.appendChild(document.createElement("div"));
            searchResultContainer.classList.add("search-suggested-order-result-container", "noselect", "terminal-d-flex", "terminal-align-items-center");

            searchResultContainer.innerHTML = `
                <div class="orderSearchResult-icon-container">
                    <i class="fa-light fa-box orderSearchResult-icon"></i>
                </div>
                <div class="orderSearchResult-info-container">
                    <p class="orderSearchResult-referenceNo">${order.referenceNo}</p>
                    <span class="orderSearchResult-orderNo">${order.orderNo}</span>
                    <span class="orderSearchResult-customerName">${customer.customerName}</span>
                </div>
                
            `;

            searchResultContainer.addEventListener('click', () => {
                if (this.callback) {
                    this.callback(order, customer);
                }

                this.close();
            });

            return searchResultContainer;
        }

    }

}